module.exports = __webpack_public_path__ + "img/element_02.3bda6dd2.png";